<template>
<v-item-group class="d-flex" >
  <v-chip :color="sample_tests.some(test => test.sample_test_type_uuid === type.uuid) ? 'error' : ''" class="text-center" v-for="type in testTypes" label small>{{type.name}}</v-chip>
</v-item-group>
</template>

<script>
export default {
  name: "SampleRequiredTests",
  props:{
    sample_tests:{
      required: true,
      type: Array
    }
  },
  computed:{
    testTypes(){
      return this.$store.$db().model("sampleTestTypes").query().orderBy("display_order").all();
    }
  }
}
</script>

<style scoped>

</style>